<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
            <FormSection title="">
              <FormRow inline>
                <LazyCurrencySelector :currencies="['USD', 'ILS']"/>
              </FormRow>
              <AmountSelector/>
              <ErrorLabel field="amount" />
              <TransactionFee />
            </FormSection>
            <FormSection title="Designation">
              <FormRow inline>
                <FormSelect field="custom.designation">
                  <option value="OU Israel Center">OU Israel Center</option>
                  <option value="Emergency Fund">Emergency Fund</option>
                  <option value="Torah Tidbits">Torah Tidbits</option>
                  <option value="Makom Balev / Gesharim">Makom Balev / Gesharim</option>
                  <option value="Oraita">Oraita</option>
                  <option value="The Zula">The Zula</option>
                  <option value="Camp Dror">Camp Dror</option>
                </FormSelect>
              </FormRow>
            </FormSection>
            <FormSection title="Your Details">
              <FormRow inline>
                <FormCol field="title" :flex="1" />
                <FormCol field="firstName" :flex="2" />
                <FormCol field="lastName" :flex="2" />
              </FormRow>
              <FormRow inline>
                <FormCol field="email" />
                <FormCol field="phone" />
              </FormRow>
              <FormRow inline>
                <FormCol field="taxId" label="Teudat Zehut" placeholder="Enter your Teudat Zehut" />
              </FormRow>
              <FormRow inline>
                <Consent privacy="https://www.ouisrael.org/privacy-policy/"/>
              </FormRow>
            </FormSection>
            <FormSection title="Billing Information">
              <DonorAddress />
            </FormSection>
            <FormSection title="Payment Information" last>
              <FormRow>
                <Receipt :receipts="['us', 'israel']" />
              </FormRow>
              <FormRow inline>
                <FormCol field="card" :showLabel="false"/>
              </FormRow>
            </FormSection>
            <PaymentButton showAmount btnText="Donate"/>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.control-label {
  font-size: 14px;
  color: #222;
}
</style>
